export default [
  {
    name: 'translations',
    path: '/translations',
    component: () => import(/* webpackChunkName: "translations" */ './Index.vue'),
    meta: {
      showNavbar: true,
      title: 'Traduções',
      icon: 'dvr',
      label: 'Traduções',
      permission: 'admin.translations.list'
    }
  }
]
